<template>
	<div class="layout-component-main">
		<div class="header">
			<slot name="header"></slot>
		</div>
		<div class="body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['$validator']
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/LayoutMainComponent.vue